module.exports = __webpack_public_path__ + "img/0xF480f38C366dAaC4305dC484b2Ad7a496FF00CeA.f67776a2.png";